"use client"

import React, { useEffect, useState } from 'react';
import {Layout, Drawer, theme, Avatar} from "antd";
import {NavMenu} from "@/theme/mainLayout/sidebar/navMenu";
import {signOut} from "next-auth/react";
import {useAuth} from "@/lib/hook";
import {UserOutlined} from "@ant-design/icons";
import {api} from "@/lib/api/api";
import {Logo} from "@/theme/ui/sidebar/logo";
import s from '@/theme/ui/sidebar/logo.module.scss'
import {Button, LanguagesSwitch, OptionsButton} from "@/theme/ui";
import {BurgerIcon, LogOutIcon} from "@/theme/assets/icons";
import classNames from "classnames";
import {useLocale, useTranslations} from "next-intl";

export const Sidebar = ({}) => {
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
    }, []);

    if (!mounted) return <></>;

    return (
        <>
            <div className={'MobileMenu'}>
                <MobileMenu />
            </div>
            <div className={'DesktopMenu'}>
                <DesktopMenu />
            </div>
        </>
    );
}

const MenuTrigger = ({collapsed, collapsedHover, setCollapsed, mobile}) =>{

    return(
        <>
            <div className={classNames('menu_trigger_wrapper', {['collapsedHover']: collapsedHover, ['mobile']: mobile})}>
                <div
                    className={'menu_trigger_button'}
                    onClick={()=>setCollapsed(!collapsed)}
                >
                    <BurgerIcon
                        className={classNames('trigger_button', {['collapsed']: mobile ? !collapsed : collapsed})}
                    />
                    {/*<div className={classNames('trigger_button', {['collapsed']: mobile ? !collapsed : collapsed})} />*/}
                </div>
                <Logo
                    mobile={mobile}
                />
            </div>
        </>
    )
}

const onClickSignOut = (locale) =>{
    api.send({
        route: {name: 'auth.logout'},
    }).then(()=>{
        signOut({
            callbackUrl: `/${locale}/sign-in`
        })
    }).finally(()=>{})
}

const MobileMenu = () =>{
    const locale = useLocale();
    const [collapsed, setCollapsed] = useState(false);
    const t = useTranslations('sidebar');
    return (
        <>
            <MenuTrigger
                collapsed={collapsed}
                setCollapsed={setCollapsed}
                mobile
            />
            <Drawer
                className={'sidebar_menu_wrapper mobile'}
                placement="left"
                onClose={()=>setCollapsed(!collapsed)}
                open={collapsed}
                closeIcon={false}
                width={255}
                styles={{
                    body: {
                        padding: 0,
                    }
                }}
            >
                <Logo />

                <LanguagesSwitch />

                <Auth />

                <NavMenu
                    collapsed={!collapsed}
                    setCollapsed={()=>{
                        setCollapsed(!!!collapsed)
                    }}
                />

                <Button
                    className={s.logout_button}
                    icon={<LogOutIcon />}
                    type={'text'}
                    onClick={() => onClickSignOut(locale)}
                >
                    {t('logout')}
                </Button>
            </Drawer>
        </>
    )
}

const DesktopMenu = () =>{
    const locale = useLocale();
    const t = useTranslations('sidebar');
    return(
        <Layout.Sider
            collapsed={false}
            style={{
                background: "#3D3D3D",
            }}
            trigger={null}
            width={256}
        >
            <div className={'sidebar_'}>
                <div
                    style={{
                        position: 'relative',
                        height: '100%',
                        width: '256px'
                    }}
                >
                    <Layout.Sider
                        className={'sidebar_menu_wrapper'}
                        style={{
                            background: "#3D3D3D",
                        }}
                        trigger={null}
                        width={256}
                        collapsedWidth={256}
                    >
                        <Logo />

                        <LanguagesSwitch />

                        <Auth />

                        <NavMenu
                            // collapsed={collapsed && collapsedHover}
                        />


                        <Button
                            className={s.logout_button}
                            icon={<LogOutIcon />}
                            type={'text'}
                            onClick={() => onClickSignOut(locale)}
                        >
                            {t('logout')}
                        </Button>
                    </Layout.Sider>
                </div>
            </div>
        </Layout.Sider>
    )
}

const Auth = () =>{
    const {user} = useAuth()
    const [preLoad, setPreLoad] = useState(false)
    const t = useTranslations('sidebar');

    const onClickSignOut = () =>{
        setPreLoad(true)
        api.send({
            route: {name: 'auth.logout'},
        }).then(()=>{
            signOut()
        }).finally(()=>{
            setPreLoad(false)
        })
    }

    return(
        <>
            <div className={'auth'}>
                <div className={'photo'}>
                    <Avatar
                        icon={<UserOutlined />}
                        size={48}
                        src={user.logo}
                    />
                </div>
                <div className={'info'}>
                    <div
                        className={'name'}
                        title={user.name}
                    >
                        {user.name ?? 'User Name'}
                    </div>
                </div>
                <div className={'options'}>
                    <OptionsButton
                        trigger={'hover'}
                        content={(
                            <>
                                {/*<div>*/}
                                    {/*<MyLink*/}
                                    {/*    route={'account'}*/}
                                    {/*>*/}
                                    {/*    <Button*/}
                                    {/*        style={{*/}
                                    {/*            width: '100%'*/}
                                    {/*        }}*/}
                                    {/*        type={'text'}*/}
                                    {/*    >*/}
                                    {/*        Account*/}
                                    {/*    </Button>*/}
                                    {/*</MyLink>*/}
                                {/*</div>*/}
                                <div>
                                    <Button
                                        style={{
                                            width: '100%'
                                        }}
                                        type={'text'}
                                        onClick={onClickSignOut}
                                        disabled={preLoad}
                                    >
                                        {t('logout')}
                                    </Button>
                                </div>
                            </>
                        )}
                    />
                </div>
            </div>
        </>
    )
}